import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useListings } from "../../hooks/useListings";

const PostDetailPage = () => {
  const { postid } = useParams();
  const navigate = useNavigate();
  const { fetchListing } = useListings();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await fetchListing(postid);
        setPost(data);
      } catch (err) {
        setError("Could not load post.");
      } finally {
        setLoading(false);
      }
    };
    load();
    // eslint-disable-next-line
  }, [postid]);

  if (loading) return <div className="p-8 text-center">Loading...</div>;
  if (error) return <div className="p-8 text-center text-red-600">{error}</div>;
  if (!post) return <div className="p-8 text-center">Post not found.</div>;

  return (
    <div className="bg-[#f7f7f7] min-h-screen">
      <div className="max-w-3xl mx-auto pt-8 px-4">
        <button
          onClick={() => navigate(-1)}
          className="text-blue-600 hover:underline text-xs mb-4"
        >
          &lt; back
        </button>
        <h1 className="text-2xl font-bold text-gray-800 mb-6">
          {post.post_title}
        </h1>
        {Array.isArray(post.images) && post.images.length > 0 && (
          <div className="flex flex-wrap gap-2 mb-4">
            {post.images.map((url, i) => (
              <img
                key={i}
                src={url}
                alt="post"
                className="h-48 w-48 object-cover border rounded"
              />
            ))}
          </div>
        )}
        <div className="mb-4 text-lg text-gray-800">{post.description}</div>
        {/* Show more post details as needed */}
        <div className="text-sm text-gray-600">
          {post.attributes && Object.keys(post.attributes).length > 0 && (
            <div className="mb-2">
              <span className="font-semibold">Details:</span>
              <ul className="list-disc ml-6 mt-1">
                {Object.entries(post.attributes).map(([key, value]) => (
                  <li key={key}>
                    <span className="font-medium">{key}:</span> {String(value)}
                  </li>
                ))}
              </ul>
            </div>
          )}
          {post.contact_email && (
            <div>
              <span className="font-medium">Contact Email:</span>{" "}
              {post.contact_email}
            </div>
          )}
          {post.phone_number && (
            <div>
              <span className="font-medium">Phone:</span> {post.phone_number}
            </div>
          )}
          {post.city && (
            <div>
              <span className="font-medium">City:</span> {post.city}
            </div>
          )}
          {post.country && (
            <div>
              <span className="font-medium">Country:</span> {post.country}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PostDetailPage;
